import { useObserver } from "mobx-react";
import {
  AiOutlineFileText,
  AiOutlineRight,
  AiOutlineVideoCamera,
} from "react-icons/ai";
import { useStores } from "../../store";
import { MdOutlineShareLocation } from "react-icons/md";
import constantVariables from "../../helpers/constantVariables";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import ReportScreen from "../reusble_components/reportScreen";
import { useEffect, useState } from "react";
import HelpCenter from "../reusble_components/helpCenter";
import PdfViewer from "../reusble_components/pdfViewer";
import ReactPaginate from "react-paginate";
import Loader from "../reusble_components/loader";
import MockExamReport from "../dashboard/mockexamreport";
import { FilterPopupForJobs } from "./Components/filterPopup";
import InterviewReport from "./interviewReport";

export default function ApplicantsDetails(props) {
  const { RecuiterStore, CommonStore, MockStore } = useStores();
  const location = useLocation();
  const [mockId, setMockId] = useState("");

  const queryParams = new URLSearchParams(location.search);
  const mid = queryParams.get("mocktestId");
  const newUI = queryParams.get("newUI");
  useEffect(() => {}, [MockStore.mockTestId]);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const clientId = searchParams.get("clientId");
  const [showFilterPopup, setShowFilterPopup] = useState(false);

  const [technology, setTechnology] = useState("");

  const [index, setIndex] = useState(0);
  useEffect(() => {
    const fetchApplicants = async () => {
      if (props.mock) {
        const res = await RecuiterStore.getApplicantsForMockTest(mid);
        if (res?.status === 200) {
           if(res.body?.data?.length > 0) {
            navigate(
              `/company/mocktest-applicants/${res.body.data[0]?._id}?mocktestId=${mid}`
            );
           }
        }
      } else {
        await getInterviewData();
        RecuiterStore.getApplicantsForInterview(id, clientId);
      }
    };
    fetchApplicants();
  }, []);

  const getInterviewData = async () => {
    const res = await RecuiterStore.getApplicantsForInterview();
    if (res?.status === 200) {
      setTechnology(res.body.data[0]?.technology);
      navigate(
        `/company/applicants/${res.body.data[0]?._id}?fromInterview=true${
          newUI ? "&newUI=true" : ""
        }`
      );
    }
  };

  const handlePageClick = (page) => {
    console.log(page.selected);
    RecuiterStore.setApplicantSkip(page.selected * 10);
    if (props.mock) {
      RecuiterStore.getApplicantsForMockTest(mid);
    } else {
      // RecuiterStore.getApplicantsForInterview();
      RecuiterStore.getApplicantsForInterview(id, clientId);
    }
  };

  const convertTimestampToDate = (timestamp) => {
    const date = new Date(timestamp);

    // Function to get the month name
    const getMonthName = (monthIndex) => {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return months[monthIndex];
    };

    // Format the date to 'Month day, year' format
    const formattedDate = `${getMonthName(
      date.getMonth()
    )} ${date.getDate()}, ${date.getFullYear()}`;

    return formattedDate;
  };

  const handleOpenFilterPopup = () => {
    setShowFilterPopup(true);
  };

  const handleCloseFilterPopup = () => {
    setShowFilterPopup(false);
  };

  const handleApplyFilters = (appliedFilters) => {
    RecuiterStore.fetchJobPostApplicationsByFilter(id, appliedFilters);
  };

  return useObserver(() => (
    <div className="w-[100%] overflow-hidden h-[100vh]">
      {CommonStore.resume && (
        <PdfViewer
          pdfUrl={CommonStore.jobresume}
          onClose={() => CommonStore.setResume(false)}
        />
      )}
      <Loader loader={RecuiterStore.loader} />
      <HelpCenter />
      <div className="w-[100%] flex  h-[100%]">
        {RecuiterStore.applicantcount > 0 ? (
          <div className="flex flex-col w-[100%] md:w-[30%] overflow-y-hidden h-[100vh]  ">
            <div className="flex items-center px-5 mt-2 justify-between">
              {/* <AiOutlineMenu
              className="hidden md:flex text-xl"
              onClick={() => {
                CommonStore.setCollapse(!CommonStore.collapse);
              }}
            /> */}
              <h1 className="md:text-lg font-semibold text-[#FF6B00] flex gap- items-center cursor-pointer">
                {/* <span className="flex items-center text-primary">
                Historty <AiOutlineRight />{" "}
              </span>
              <span>{RecuiterStore.tech}</span> */}
                <span
                  className="flex "
                  onClick={() =>
                    navigate(`/company/activity?page=0&button=Interviews`)
                  }
                >
                  Applicants
                </span>{" "}
                {""} <AiOutlineRight className="text-base" />{" "}
                {technology !== "" ? technology : props.mock ? "MCQ" : "HR Interview"}
              </h1>
              {/* <button
                className="p-2 rounded flex justify-center gap-3 items-center"
                onClick={handleOpenFilterPopup}
              >
                <MdOutlineFilterAlt color="gray" />
              </button> */}
            </div>

            <div
              className="flex flex-col justify-between items-center mt-2 h-full w-full overflow-y-auto"
              style={{ scrollbarWidth: 0 }}
            >
              <div className="flex flex-col gap-5">
                {RecuiterStore.applicantcount > 0 ? (
                  <>
                    {RecuiterStore.InterviewApplicants.map((item, key) => (
                      <div
                        key={key}
                        className={` w-[100%] lg:w-[32%]  md:w-[32%] min-w-fit mx-2 px-7 cursor-pointer py-2  rounded-xl ${
                          key === index ? " border border-primary " : "bg-white"
                        }`}
                        // style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)" }}
                        style={
                          key === index
                            ? { boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 0px" }
                            : { boxShadow: "rgb(0 0 0 / 5%) 0px 0px 20px 10px" }
                        }
                        onClick={() => {
                          setIndex(key);
                          if (props.mock) {
                            MockStore.setMockId(item._id);
                            if (window.innerWidth < 999) {
                              navigate(
                                `/mockexamreport/${item._id}?mocktestId=${mid}`
                              );
                              return;
                              // navigate(`/report/${item._id}`);
                              // return;
                            }
                            if (JSON.parse(localStorage.getItem("user"))?._id) {
                              navigate(
                                `/company/mocktest-applicants/${item._id}?mocktestId=${mid}`
                              );
                            } else {
                              navigate(
                                `/share/mcq-applicants/${item._id}?mocktestId=${mid}`
                              );
                            }
                          } else {
                            if (window.innerWidth < 999) {
                              navigate(`/report/${item._id}`);
                              return;
                            }
                            if (id) {
                              return navigate(
                                `/share/applicants/${item._id}?id=${id}`
                              );
                            }
                            navigate(
                              `/company/applicants/${
                                item._id
                              }?fromInterview=true${newUI ? "&newUI=true" : ""}`
                            );
                          }
                        }}
                      >
                        <div className="flex items-center py-2 gap-4">
                          <img
                            src={ props.mock ? item?.candidate?.pic : 
                              item?.interviewee?.pic
                                ? item?.interviewee?.pic
                                : constantVariables.defaultProfilePic
                            }
                            alt=""
                            className="h-10 w-10 rounded-full object-cover"
                            onError={(e) => {
                              e.target.src =
                                constantVariables.defaultProfilePic;
                            }}
                          />
                          <div>
                            <h1 className=" gil-med w-40 truncate ">
                              {/* Topic:{" "} */}
                              {props.mock ? item?.candidate?.name : item?.interviewee?.name}
                            </h1>
                            <p className=" text-sm opacity-50">
                              {convertTimestampToDate(item?.createdAt)}
                            </p>
                            <p className=" text-xs  flex flex-row items-center ">
                              <MdOutlineShareLocation /> &nbsp;
                              <span className="opacity-30">
                                {" "}
                                {props.mock ? item?.candidate?.city : item?.interviewee?.city ??
                                  "No city available !"}
                              </span>
                            </p>
                          </div>
                        </div>

                        {/* interviewData?.technology === "" ? interviewData?.role : interviewData?.technology */}
                        {props.mock ? (
                          <div className="flex my-3 gap-4">
                            <div>
                              {" "}
                              <h1 className="text-lg font-semibold">
                                {Math.trunc(props.mock ? item?.numberOfCorrect : item?.numberOfCorrect)}
                              </h1>{" "}
                              <p className="text-xs opacity-30">Correct</p>{" "}
                            </div>
                            <div>
                              {" "}
                              <h1 className="text-lg font-semibold">
                                {Math.trunc(props.mock ? item?.numberOfIncorrect : item?.numberOfIncorrect)}
                              </h1>{" "}
                              <p className="text-xs opacity-30">Incorrect</p>{" "}
                            </div>
                            <div>
                              {" "}
                              <h1 className="text-lg font-semibold">
                                {Math.trunc(props.mock ? item?.numberOfUnanswered : item?.numberOfUnanswered)}
                              </h1>{" "}
                              <p className="text-xs opacity-30">Unanswered</p>{" "}
                            </div>
                          </div>
                        ) : (
                          <div className="flex my-3 gap-4">
                            <div>
                              <h1 className="text-lg font-semibold">
                                {item?.result[2]?.score != null
                                  ? `${Math.trunc(item.result[2].score)}%`
                                  : "-"}
                              </h1>
                              <p className="text-xs opacity-30">
                                Communication
                              </p>
                            </div>
                            <div>
                              <h1 className="text-lg font-semibold">
                                {item?.result[1]?.score != null
                                  ? `${Math.trunc(item.result[1].score)}%`
                                  : "-"}
                              </h1>
                              <p className="text-xs opacity-30">
                                Technical skills
                              </p>
                            </div>
                            <div>
                              <h1 className="text-lg font-semibold">
                                {item?.result[0]?.score != null
                                  ? `${Math.trunc(item.result[0].score)}%`
                                  : "-"}
                              </h1>
                              <p className="text-xs opacity-30">
                                Overall score
                              </p>
                            </div>
                          </div>
                        )}
                        {/* <Link to={`/company/report/${item._id}`}> */}
                        <p
                          className="flex items-center justify-between my-4 cursor-pointer "
                          onClick={() => {}}
                        >
                          {" "}
                          {/* {!props.mock && (
                            <span className="flex items-center">
                              {item?.recording ? (
                                <AiOutlineVideoCamera className="  text-xl text-primary opacity-75" />
                              ) : (
                                <AiOutlineVideoCamera className="opacity-10 text-xl" />
                              )}
                              {item?.resumeLink ? (
                                <AiOutlineFileText className=" ml-3 text-xl text-primary opacity-75" />
                              ) : (
                                <AiOutlineFileText className=" ml-3 text-xl opacity-10" />
                              )}
                            </span>
                          )} */}
                          {/* <p className="text-sm text-primary ml-auto">View More </p>{" "}
                <CiCircleChevRight className="mt-1 mx-2" />{" "} */}
                          {/* <button
                    className="text-primary underline"
                    onClick={() => {
                      setIndex(key);
                      if (window.innerWidth < 999) {
                        navigate(`/report/${item._id}`);
                        return;
                      }
                      navigate(`/company/applicants/${item._id}`);
                    }}
                  >
                    view more
                  </button> */}
                        </p>
                        {/* </Link> */}
                      </div>
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </div>
              {RecuiterStore.applicantcount > 10 && (
                <div className="fixed w-full bottom-0 md:w-[20%] bg-white py-1">
                  <ReactPaginate
                    nextLabel=" >"
                    className="flex justify-center items-center gap-5 "
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={2}
                    pageCount={RecuiterStore.applicantcount / 10}
                    previousLabel="< "
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active-page-item"
                    activeLinkClassName="active-page-link"
                    renderOnZeroPageCount={null}
                  />
                </div>
              )}
            </div>
          </div>
        ) : null}
        <div className="hidden relative md:flex w-[100%] overflow-y-auto">
          {props.mock ? (
            <>
              {RecuiterStore.applicantcount > 0 ? (
                <MockExamReport commingFrom={"company"} />
              ) : (
                <h1 className="mx-auto mt-[50vh] text-2xl text-primary w-fit h-fit">
                  No Applicants Found {RecuiterStore.applicantcount}
                </h1>
              )}
            </>
          ) : (
            <>
              {RecuiterStore.applicantcount > 0 ? (
                true ? (
                  <InterviewReport />
                ) : (
                  <ReportScreen />
                )
              ) : (
                <h1 className="mx-auto mt-[50vh] text-2xl text-primary w-fit h-fit">
                  No Applicants Found
                </h1>
              )}
            </>
          )}
          {/* <ReportScreen /> */}
        </div>
      </div>
      <FilterPopupForJobs
        show={showFilterPopup}
        onClose={handleCloseFilterPopup}
        onApply={handleApplyFilters}
      />
    </div>
  ));
}
